module.exports = __webpack_public_path__ + "static/761aa6077537af77bc56dd192655c71a984ec6ca17aef271c2cd38f3a6aa94aa-e441d0a9a611cbc5022ef5b4b8088e5c.png";